import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

export default withStyles(styles)(props => (
  <div style={{ height: props.spacer ? 'inherit' : '' }}>{props.children}</div>
));
